import { useTranslation } from "react-i18next";

const Pricing = () => {
  const { t } = useTranslation();

  return (
    <section className="w-10/12 md:w-1/2 lg:w-2/6 max-w-[400px] lg:min-h-[440px] px-6 py-6 flex justify-center items-center bg-gradient shadow-lg overflow-auto custom-scrollbar">
      <div className="flex flex-col flex-1 max-h-96">
        <div>
          <h2 className="text-2xl font-bold text-center mb-4">STYLING</h2>
          <table className="table-auto w-full text-left text-sm md:text-lg">
            <tbody>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">
                    NOT ORDINARY <span className="font-bold">HAIRCUT</span>
                  </p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("styling.not_ordinary_haircut.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium">20&euro;</td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("styling.beard.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("styling.beard.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium">15&euro;</td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("styling.combo.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("styling.combo.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium">30&euro;</td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">
                    NOT ORDINARY <span className="font-bold">BEARD</span>
                  </p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("styling.not_ordinary_beard.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium">20&euro;</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2 className="text-2xl font-bold text-center mb-4 mt-4">TREATMENTS</h2>
          <table className="table-auto w-full text-left mb-4 text-sm md:text-lg">
            <tbody>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("treatments.coloring.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("treatments.coloring.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium" style={{ whiteSpace: "nowrap" }}>
                  <span className="text-xs md:text-sm font-light mr-1">{t("misc.from")}</span>
                  25&euro;
                </td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("treatments.beard_coloring.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("treatments.beard_coloring.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium" style={{ whiteSpace: "nowrap" }}>
                  <span className="text-xs md:text-sm font-light mr-1">{t("misc.from")}</span>
                  10&euro;
                </td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("treatments.bleaching.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("treatments.bleaching.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium" style={{ whiteSpace: "nowrap" }}>
                  <span className="text-xs md:text-sm font-light mr-1">{t("misc.from")}</span>
                  70&euro;
                </td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("treatments.perm.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("treatments.perm.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium" style={{ whiteSpace: "nowrap" }}>
                  <span className="text-xs md:text-sm font-light mr-1">{t("misc.from")}</span>
                  30&euro;
                </td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("treatments.shampeeling.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("treatments.shampeeling.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium">10&euro;</td>
              </tr>
              <tr className="odd:bg-odd-table-gray">
                <td className="p-2">
                  <p className="pb-1">{t("treatments.anti_hair_loss.title")}</p>
                  <p className="text-xs md:text-sm tracking-widest leading-snug">
                    {t("treatments.anti_hair_loss.des")}
                  </p>
                </td>
                <td className="p-2 text-right font-medium">7&euro;</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
